/* eslint-disable max-classes-per-file */
import { IsTimestamp } from '../utils/decorators';

export interface Created {
  created?: CreatedInfo;
}

export class CreatedInfo {
  readonly by: string;

  @IsTimestamp()
  readonly at: Date;

  constructor(init: CreatedInfo);

  constructor(init?: CreatedInfo) {
    this.by = init?.by!;
    this.at = init?.at!;
  }
}

export default CreatedInfo;
